var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../../lib/interactjs/dist/interact", "../LayoutDesigner/LayoutElement"], function (require, exports, interact, LayoutElement_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ConfigurationVirtualScreenElement = (function (_super) {
        __extends(ConfigurationVirtualScreenElement, _super);
        function ConfigurationVirtualScreenElement(width, height, x, y, id, parent, layout) {
            if (layout === void 0) { layout = null; }
            var _this = _super.call(this, width, height, x, y, id, parent, layout) || this;
            var jqHeaderElement = _this.element.children('[data-type="header"]').first();
            _this.editButton = $('<button class="EditContentButton"><span class="k-icon k-i-delete"></span></button>');
            jqHeaderElement.append(_this.editButton);
            interact(_this.editButton.first().get(0)).on('tap', _this.OnDeleteClicked.bind(_this));
            _this.stateButton = $('<button id="switchStateButton" style="float:right; margin:2px;" class="GreenDot"><span class="ua-icon-off" style="width:10px; height:10px"></span></button>');
            jqHeaderElement.append(_this.stateButton);
            interact(_this.stateButton.first().get(0)).on('tap', _this.StateClicked.bind(_this));
            _this.ClassName = "ConfigVirtualScreenRect Dragable";
            _this.SelectedClassName = "SelectedConfigVirtualScreenRect Dragable";
            return _this;
        }
        ConfigurationVirtualScreenElement.prototype.OnDeleteClicked = function () {
            this.FireEvent("DeleteContentClicked", { element: this });
        };
        ConfigurationVirtualScreenElement.prototype.StateClicked = function () {
            console.log("StateClicked");
            this.SwitchVirtualScreenState();
            this.FireEvent("SwitchStateClicked", { element: this });
        };
        ConfigurationVirtualScreenElement.prototype.UpdateStateUI = function () {
            var virtualScreen = this.object.VirtualScreen;
            if (virtualScreen.State == "on")
                this.stateButton.attr("class", "GreenDot");
            else
                this.stateButton.attr("class", "RedDot");
        };
        ConfigurationVirtualScreenElement.prototype.SwitchVirtualScreenState = function () {
            var virtualScreen = this.object.VirtualScreen;
            if (virtualScreen.State == "on")
                virtualScreen.State = "off";
            else
                virtualScreen.State = "on";
            this.UpdateStateUI();
        };
        return ConfigurationVirtualScreenElement;
    }(LayoutElement_1.LayoutElement));
    exports.ConfigurationVirtualScreenElement = ConfigurationVirtualScreenElement;
});
//# sourceMappingURL=ConfigurationVirtualScreenElement.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/ConfigurationDesigner/ConfigurationVirtualScreenElement.js
// module id = 387
// module chunks = 0